import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { places } from "@/mocks/places";
import { restaurants } from "@/mocks/restaurants";

interface Region {
  id: string;
  name: string;
  description: string;
  highlights: string[];
  image: string;
  color: string;
  mapQuery: string;
  icon: string;
  placeRegion: string;
  restRegion: string;
}

const regions: Region[] = [
  {
    id: "marmara",
    name: "Marmara",
    description: "İstanbul'un kozmopolit enerjisi, Bursa'nın Osmanlı mirası ve İznik'in kadim çinileriyle Türkiye'nin en dinamik bölgesi.",
    highlights: ["İstanbul", "Bursa & Uludağ", "İznik", "Edirne"],
    image: "https://readdy.ai/api/search-image?query=Istanbul%20Turkey%20Bosphorus%20bridge%20city%20skyline%20minarets%20dramatic%20sunset%20golden%20hour%20Marmara%20region&width=600&height=400&seq=reg-marmara&orientation=landscape",
    color: "from-rose-900/80",
    mapQuery: "Marmara Region Turkey",
    icon: "ri-building-2-line",
    placeRegion: "Marmara",
    restRegion: "Marmara",
  },
  {
    id: "ege",
    name: "Ege",
    description: "Antik kentler, zeytinlikler, rüzgar sörfü ve Türkiye'nin en güzel kıyı kasabalarıyla Akdeniz yaşam tarzının özü.",
    highlights: ["Efes", "Pamukkale", "Alaçatı", "Bodrum"],
    image: "https://readdy.ai/api/search-image?query=Aegean%20Turkey%20Alacati%20stone%20houses%20bougainvillea%20Bodrum%20white%20houses%20blue%20sea%20summer%20beautiful&width=600&height=400&seq=reg-ege&orientation=landscape",
    color: "from-sky-900/80",
    mapQuery: "Aegean Region Turkey",
    icon: "ri-sailboat-line",
    placeRegion: "Ege",
    restRegion: "Ege",
  },
  {
    id: "akdeniz",
    name: "Akdeniz",
    description: "Ölüdeniz'in turkuaz lagünü, Antalya'nın tarihi limanı ve antik Likya yoluyla Türkiye'nin en popüler tatil bölgesi.",
    highlights: ["Ölüdeniz", "Antalya Kaleiçi", "Likya Yolu", "Aspendos"],
    image: "https://readdy.ai/api/search-image?query=Oludeniz%20Turkey%20blue%20lagoon%20turquoise%20Mediterranean%20Antalya%20coast%20summer%20paradise%20aerial&width=600&height=400&seq=reg-akdeniz&orientation=landscape",
    color: "from-teal-900/80",
    mapQuery: "Mediterranean Region Turkey",
    icon: "ri-sun-line",
    placeRegion: "Akdeniz",
    restRegion: "Akdeniz",
  },
  {
    id: "ic-anadolu",
    name: "İç Anadolu",
    description: "Kapadokya'nın peri bacaları, Konya'nın manevi derinliği ve bozkırın sonsuz ufkuyla Anadolu'nun kalbi.",
    highlights: ["Kapadokya", "Konya & Mevlana", "Ankara", "Tuz Gölü"],
    image: "https://readdy.ai/api/search-image?query=Cappadocia%20Turkey%20hot%20air%20balloons%20fairy%20chimneys%20sunrise%20golden%20magical%20landscape%20Central%20Anatolia&width=600&height=400&seq=reg-ic-anadolu&orientation=landscape",
    color: "from-amber-900/80",
    mapQuery: "Central Anatolia Turkey",
    icon: "ri-landscape-line",
    placeRegion: "İç Anadolu",
    restRegion: "İç Anadolu",
  },
  {
    id: "guneydogu-anadolu",
    name: "Güneydoğu",
    description: "Göbeklitepe'nin 12.000 yıllık sırrı, Mardin'in taş evleri ve Gaziantep'in efsanevi baklavasıyla insanlığın beşiği.",
    highlights: ["Göbeklitepe", "Mardin", "Gaziantep", "Halfeti"],
    image: "https://readdy.ai/api/search-image?query=Mardin%20Turkey%20stone%20city%20hilltop%20Mesopotamia%20plain%20golden%20sunset%20ancient%20architecture%20Southeast%20Anatolia&width=600&height=400&seq=reg-guneydogu&orientation=landscape",
    color: "from-orange-900/80",
    mapQuery: "Southeast Anatolia Turkey",
    icon: "ri-ancient-gate-line",
    placeRegion: "Güneydoğu Anadolu",
    restRegion: "Güneydoğu Anadolu",
  },
  {
    id: "karadeniz",
    name: "Karadeniz",
    description: "Ayder'in yemyeşil yaylaları, Sümela'nın kayalık manastırı ve Safranbolu'nun Osmanlı konakları — Türkiye'nin en yeşil bölgesi.",
    highlights: ["Ayder Yaylası", "Sümela Manastırı", "Uzungöl", "Safranbolu"],
    image: "https://readdy.ai/api/search-image?query=Ayder%20plateau%20Rize%20Turkey%20lush%20green%20mountains%20waterfall%20Black%20Sea%20region%20misty%20morning%20beautiful%20nature&width=600&height=400&seq=reg-karadeniz&orientation=landscape",
    color: "from-emerald-900/80",
    mapQuery: "Black Sea Region Turkey",
    icon: "ri-plant-line",
    placeRegion: "Doğu Karadeniz",
    restRegion: "Doğu Karadeniz",
  },
  {
    id: "dogu-anadolu",
    name: "Doğu Anadolu",
    description: "Nemrut'un devasa heykelleri, Van Gölü'nün masmavi suları ve İshak Paşa Sarayı'nın görkemiyle Türkiye'nin en gizemli bölgesi.",
    highlights: ["Nemrut Dağı", "Van Gölü", "İshak Paşa Sarayı", "Ani Harabeleri"],
    image: "https://readdy.ai/api/search-image?query=Nemrut%20Mountain%20Turkey%20giant%20stone%20heads%20statues%20sunrise%20dramatic%20sky%20Eastern%20Anatolia%20ancient&width=600&height=400&seq=reg-dogu-anadolu&orientation=landscape",
    color: "from-stone-900/80",
    mapQuery: "Eastern Anatolia Turkey",
    icon: "ri-landscape-line",
    placeRegion: "Doğu Anadolu",
    restRegion: "Doğu Anadolu",
  },
  {
    id: "trakya",
    name: "Trakya",
    description: "Selimiye'nin görkemli kubbesi, İğneada'nın longoz ormanları ve Trakya bağlarının şaraplarıyla Avrupa yakasının incisi.",
    highlights: ["Edirne & Selimiye", "İğneada Longoz", "Vize", "Kırklareli Bağları"],
    image: "https://readdy.ai/api/search-image?query=Edirne%20Selimiye%20Mosque%20Turkey%20Ottoman%20architecture%20minarets%20dome%20Thrace%20region%20beautiful%20sunset&width=600&height=400&seq=reg-trakya&orientation=landscape",
    color: "from-violet-900/80",
    mapQuery: "Thrace Region Turkey",
    icon: "ri-goblet-line",
    placeRegion: "Trakya",
    restRegion: "Trakya",
  },
];

const RegionExplorer = () => {
  const navigate = useNavigate();
  const [activeRegion, setActiveRegion] = useState<Region>(regions[0]);
  const [activeTab, setActiveTab] = useState<"places" | "restaurants">("places");

  // Filter places and restaurants for active region
  const regionPlaces = places
    .filter((p) => p.region === activeRegion.placeRegion)
    .slice(0, 4);

  const regionRestaurants = restaurants
    .filter((r) => r.region === activeRegion.restRegion)
    .slice(0, 4);

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="flex items-end justify-between mb-10">
          <div>
            <span className="text-amber-500 text-sm font-semibold uppercase tracking-widest">Türkiye Haritası</span>
            <h2
              className="text-3xl md:text-4xl font-bold text-stone-900 mt-2"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Bölgeye Göre<br />Keşfet
            </h2>
          </div>
          <p className="hidden md:block text-stone-400 text-sm max-w-xs text-right leading-relaxed">
            Türkiye'nin 8 coğrafi bölgesini keşfedin — her biri farklı bir kültür, doğa ve lezzet dünyası sunar.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
          {/* Left: Region List */}
          <div className="lg:col-span-2 grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-2 gap-2">
            {regions.map((region) => {
              const pCount = places.filter((p) => p.region === region.placeRegion).length;
              const rCount = restaurants.filter((r) => r.region === region.restRegion).length;
              const isActive = activeRegion.id === region.id;
              return (
                <button
                  key={region.id}
                  onClick={() => { setActiveRegion(region); setActiveTab("places"); }}
                  className={`relative overflow-hidden rounded-xl text-left transition-all duration-200 cursor-pointer group ${
                    isActive ? "ring-2 ring-amber-400 scale-[1.02]" : "hover:scale-[1.01]"
                  }`}
                  style={{ height: "80px" }}
                >
                  <img
                    src={region.image}
                    alt={region.name}
                    className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className={`absolute inset-0 bg-gradient-to-t ${region.color} to-transparent`}></div>
                  <div className="absolute inset-0 flex flex-col justify-end p-3">
                    <p className="text-white font-bold text-sm leading-tight">{region.name}</p>
                    <p className="text-white/70 text-xs mt-0.5">
                      {pCount} yer{rCount > 0 ? ` · ${rCount} restoran` : ""}
                    </p>
                  </div>
                  {isActive && (
                    <div className="absolute top-2 right-2 w-5 h-5 flex items-center justify-center bg-amber-400 rounded-full">
                      <i className="ri-check-line text-white text-xs"></i>
                    </div>
                  )}
                </button>
              );
            })}
          </div>

          {/* Right: Active Region Detail */}
          <div className="lg:col-span-3 flex flex-col gap-4">
            {/* Hero Image */}
            <div className="relative rounded-2xl overflow-hidden" style={{ height: "200px" }}>
              <img
                key={activeRegion.id}
                src={activeRegion.image}
                alt={activeRegion.name}
                className="w-full h-full object-cover object-top"
              />
              <div className={`absolute inset-0 bg-gradient-to-t ${activeRegion.color} to-transparent`}></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <h3
                  className="text-xl font-bold text-white mb-1"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  {activeRegion.name} Bölgesi
                </h3>
                <p className="text-white/80 text-xs leading-relaxed line-clamp-2">
                  {activeRegion.description}
                </p>
              </div>
            </div>

            {/* Tab Switcher */}
            <div className="flex items-center gap-2">
              <div className="flex items-center bg-stone-100 rounded-full p-1 gap-1">
                <button
                  onClick={() => setActiveTab("places")}
                  className={`px-4 py-1.5 rounded-full text-xs font-medium transition-all cursor-pointer whitespace-nowrap ${
                    activeTab === "places"
                      ? "bg-white text-stone-800 shadow-sm"
                      : "text-stone-500 hover:text-stone-700"
                  }`}
                >
                  <i className="ri-map-2-line mr-1"></i>
                  Gezilecek Yerler ({places.filter((p) => p.region === activeRegion.placeRegion).length})
                </button>
                <button
                  onClick={() => setActiveTab("restaurants")}
                  className={`px-4 py-1.5 rounded-full text-xs font-medium transition-all cursor-pointer whitespace-nowrap ${
                    activeTab === "restaurants"
                      ? "bg-white text-stone-800 shadow-sm"
                      : "text-stone-500 hover:text-stone-700"
                  }`}
                >
                  <i className="ri-restaurant-line mr-1"></i>
                  Restoranlar ({restaurants.filter((r) => r.region === activeRegion.restRegion).length})
                </button>
              </div>
              <div className="ml-auto flex gap-2">
                <button
                  onClick={() => navigate(`/places?region=${activeRegion.id}`)}
                  className="flex items-center gap-1.5 py-1.5 px-3 bg-stone-900 text-white text-xs font-medium rounded-full hover:bg-stone-700 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-arrow-right-line"></i> Tümünü Gör
                </button>
              </div>
            </div>

            {/* Content Grid */}
            {activeTab === "places" ? (
              regionPlaces.length > 0 ? (
                <div className="grid grid-cols-2 gap-3">
                  {regionPlaces.map((place) => (
                    <Link
                      key={place.id}
                      to={`/place/${place.id}`}
                      className="group relative rounded-xl overflow-hidden cursor-pointer"
                      style={{ height: "110px" }}
                    >
                      <img
                        src={place.image}
                        alt={place.name}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
                      <div className="absolute bottom-0 left-0 right-0 p-3">
                        <p className="text-white font-bold text-xs leading-tight">{place.name}</p>
                        <div className="flex items-center gap-1 mt-0.5">
                          <i className="ri-map-pin-line text-amber-400 text-xs"></i>
                          <span className="text-white/70 text-xs">{place.city}</span>
                          <span className="ml-auto flex items-center gap-0.5">
                            <i className="ri-star-fill text-amber-400 text-xs"></i>
                            <span className="text-white text-xs font-medium">{place.rating}</span>
                          </span>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              ) : (
                <div className="flex flex-col items-center justify-center py-8 bg-stone-50 rounded-xl">
                  <i className="ri-map-2-line text-stone-300 text-3xl mb-2"></i>
                  <p className="text-stone-400 text-sm">Bu bölge için henüz yer eklenmedi</p>
                </div>
              )
            ) : (
              regionRestaurants.length > 0 ? (
                <div className="grid grid-cols-2 gap-3">
                  {regionRestaurants.map((rest) => (
                    <Link
                      key={rest.id}
                      to={`/restaurant/${rest.id}`}
                      className="group flex gap-2.5 bg-stone-50 rounded-xl p-2.5 border border-stone-100 hover:border-amber-200 transition-all cursor-pointer"
                    >
                      <div className="w-14 h-14 rounded-lg overflow-hidden flex-shrink-0">
                        <img
                          src={rest.image}
                          alt={rest.name}
                          className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                        />
                      </div>
                      <div className="flex-1 min-w-0">
                        <p
                          className="font-bold text-stone-900 text-xs leading-snug line-clamp-1 group-hover:text-amber-700 transition-colors"
                          style={{ fontFamily: "'Playfair Display', serif" }}
                        >
                          {rest.name}
                        </p>
                        <p className="text-stone-400 text-xs mt-0.5 line-clamp-1">{rest.city}</p>
                        <div className="flex items-center gap-1.5 mt-1">
                          <i className="ri-star-fill text-amber-400 text-xs"></i>
                          <span className="text-xs font-semibold text-stone-700">{rest.rating}</span>
                          <span className="text-xs text-amber-600 font-bold ml-auto">{rest.priceRange}</span>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              ) : (
                <div className="flex flex-col items-center justify-center py-8 bg-stone-50 rounded-xl">
                  <i className="ri-restaurant-line text-stone-300 text-3xl mb-2"></i>
                  <p className="text-stone-400 text-sm">Bu bölge için henüz restoran eklenmedi</p>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default RegionExplorer;
